export interface InformationHeader {
  hdiw: boolean;
  faq: boolean;
  tutorResources: boolean;
  offlineTool: boolean;
  externalAssessment: boolean;
  transferLearning: boolean;
  misAgentTool: boolean;
  learnerGuide: boolean;
};

export const initialInformationHeader: InformationHeader = {
  hdiw: false,
  faq: false,
  tutorResources: false,
  offlineTool: false,
  externalAssessment: false,
  transferLearning: false,
  misAgentTool: false,
  learnerGuide: false,
};

export const learnerInformationHeader: InformationHeader = {
  ...initialInformationHeader,
  hdiw: true,
  faq: true,
  externalAssessment: true,
  learnerGuide: true,
};

export const tutorInformationHeader: InformationHeader = {
  ...initialInformationHeader,
  hdiw: true,
  faq: true,
  tutorResources: true,
  offlineTool: true,
  externalAssessment: true,
  transferLearning: true,
  learnerGuide: true,
};

export const adminInformationHeader: InformationHeader = {
  hdiw: true,
  faq: true,
  tutorResources: true,
  offlineTool: true,
  externalAssessment: true,
  transferLearning: true,
  misAgentTool: true,
  learnerGuide: true,
};